module.exports = __webpack_public_path__ + "img/head.5cb108ca.png";